import Vue from 'vue'

const addLayerColumn = (state, { layerId, column }) => {
  const index = state.layersBase.findIndex(x => x.ObjectId === layerId)
  if (index === -1) return false
  state.layersBase[index].Query.select.push(column)

}
const setFeatureLayer = (state, payload) => {
  const index = state.layersBase.findIndex(x => x.Alias === payload.Alias)
  if (index === -1) {
    // Camada ainda não presente (ex.: recém-adicionada, populada de forma
    // assíncrona pelo mapAdapter). Adiciona de forma reativa em vez de descartar
    // a atualização silenciosamente - evita o "Não há camadas válidas" na corrida.
    state.layersBase.push(payload)
    return
  }
  // Vue.set garante reatividade: atribuição por índice (layersBase[i] = x) não é
  // detectada pelo Vue 2, deixando computeds como onlyUserDraw/activeLayers/
  // visibleLayers com cache velho ate o proximo re-render.
  Vue.set(state.layersBase, index, payload)
}
const setGeoPopLevels = (state, payload) => { state.geoPopLevels = payload }
const setLayersBase = (state, payload) => { state.layersBase = payload }
const setAddLayerBase = (state, payload) => { state.layersBase.unshift(payload) }
const setNewLayer = (state, payload) => { state.newLayer = payload }
const setStatusLayer = (state, payload) => { state.statusLayer = payload }
const updateDataVis = (state, payload) => {
  const item = state.layerList.find(item => item.id === payload.id)
  const layer = item.object.layer
  layer.jbData.config.datavis = payload.datavis
}
const updateStyle = (state, payload) => {
  const item = state.layerList.find(item => item.id === payload.id)
  const layer = item.object.layer
  layer.jbData.config.datavis.style = payload.style
}
const pushMapMarker = (state, marker) => {
  state.mapMarkers.push(marker)
}
const removeLayerColumn = (state, {layerId, column}) => {
  const index = state.layersBase.findIndex(x => x.ObjectId === layerId)
  if (index === -1) return false
  state.layersBase[index].Query.select = state.layersBase[index].Query.select.filter(x => x.id !== column.id)
  // state.layers[index].draft.dirty = true
}
const setRemoveLayerBase = (state, payload) => {
  // state.layersBase.splice(state.layersBase.findIndex(e => e === payload), 1)
  state.layersBase.splice(state.layersBase.findIndex(e => e.layer.gdIdEvent === payload.gdIdEvent))
}
const setLoading = (state, payload) => {
  state.loading = payload
}
const setLayersMenu = (state, payload) => {
  state.layersMenu = payload
}
const setEnvironmentDataMenu = (state, menuId) => {
  state.environmentDataMenu = menuId
}
const renameLayer = (state, { layerId, newName, isUpload }) => {
  if (isUpload) {
    const idx = state.uploadLayers.findIndex(e => e.layerId === layerId)
    if (idx !== -1) {
      state.uploadLayers[idx].name = newName
    }
  } else {
    const idx = state.layersBase.findIndex(e => e.ObjectId === layerId)
    if (idx !== -1) {
      state.layersBase[idx].Name = newName
    }
  }
}
const deleteLayer = (state, { layerId }) => {
  const idx = state.layersBase.findIndex(e => e.ObjectId === layerId)
  if (idx !== -1) state.layersBase.splice(idx, 1)
}
const removeReference = (state, { layerId }) => {
  const idx = state.layersBase.findIndex(e => e.layer.ObjectId === layerId)
  if (idx !== -1) state.layersBase.splice(idx, 1)
}
const togglePromotion = (state, { layerId, isUpload }) => {
  if (isUpload) {
    const idx = state.uploadLayers.findIndex(e => e.layerId === layerId)
    if (idx !== -1) {
      const row = state.uploadLayers[idx]
      const layer = row.object.layer
      if (!layer.jbData.config.hasOwnProperty('promoted')) layer.jbData.config.promoted = false
      layer.jbData.config.promoted = !layer.jbData.config.promoted
    }
  } else {
    const idx = state.layersBase.findIndex(e => e.ObjectId === layerId)
    if (idx !== -1) {
      state.layersBase[idx].IsPromoted = !state.layersBase[idx].IsPromoted
    }
  }
}
const toggleVisibility = (state, layerId) => {
  if (!state.layers.has(layerId)) return false
  const featureLayer = state.layers.get(layerId)
  featureLayer.visible = !featureLayer.visible
}

export default {
  addLayerColumn,
  deleteLayer,
  removeLayerColumn,
  removeReference,
  renameLayer,
  setEnvironmentDataMenu,
  setLayersMenu,
  setLoading,
  setGeoPopLevels,
  setLayersBase,
  setAddLayerBase,
  setRemoveLayerBase,
  setFeatureLayer,
  setNewLayer,
  setStatusLayer,
  togglePromotion,
  toggleVisibility,
  updateDataVis,
  updateStyle
}
